import React, { useEffect, useState } from "react";
import {
    Button,
    Row,
    Container,
    Col,
    Navbar,
    Spinner
} from "react-bootstrap";
import logo from '../pinLogo2.png'
import Banner from '../images/PinStackHome.jpg'
import API from "../utils/API";
import { useParams, useNavigate } from "react-router-dom";
function Home() {
    const [isError, setIsError] = useState(false)
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true)
    const [homeData, setHomeData] = useState([])
    const { id } = useParams();
    const [retrived, setRetrieved] = useState(true)
    useEffect(() => {
        retrieveData();
    }, [isLoading]);

    useEffect(() => {
        if (homeData.Status === 'Cancelled') {
            navigate(`/${id}/expired`);
        }

        const dateTime = new Date(homeData.ContractEXP);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (dateTime < today) {
            navigate(`/${id}/expired`);
        }
    }, [homeData]);

    async function retrieveData() {

        await API.getContractData(id)
            .then((res) => {
                // console.log(res.messages[0].code)

                if (res.messages[0].code === '401') {
                    // console.log('nothing found')
                    setRetrieved(false)
                }
                setHomeData({
                    "ContractType": res.response.data[0].fieldData["ContractType"],
                    "Client_Organization": res.response.data[0].fieldData["AccountContacts::Client_Organization"],
                    "AlcoholBEOTotalTax": res.response.data[0].fieldData["Alcohol BEOTotal Tax"],
                    "AlcoholBEOTotal": res.response.data[0].fieldData["AlcoholBEOTotal"],
                    "Balance": res.response.data[0].fieldData["Balance"],
                    "BillingAddress": res.response.data[0].fieldData["Billing Address"],
                    "BookingContactEmail": res.response.data[0].fieldData["BookingContactEmail"],
                    "BookingContactFullName": res.response.data[0].fieldData["BookingContactFullName"],
                    "BookingContactPhone": res.response.data[0].fieldData["BookingContactPhone"],
                    "BowlingBEOTotalAll": res.response.data[0].fieldData["Bowling BEOTotal All"],
                    "BowlingBEOTotal": res.response.data[0].fieldData["Bowling BEOTotal"],
                    "BowlingBEOTotalServiceFeeLine": res.response.data[0].fieldData["Bowling BEOTotal ServiceFeeLine"],
                    "BowlingBEOTotalTax": res.response.data[0].fieldData["Bowling BEOTotal Tax"],
                    "ContractBottomBirthday": res.response.data[0].fieldData["ContractBottom Birthday"],
                    "ContractBottomCE": res.response.data[0].fieldData["ContractBottom CE"],
                    "ContractTopBirthday": res.response.data[0].fieldData["ContractTop Birthday"],
                    "ContractTopCE": res.response.data[0].fieldData["ContractTop CE"],
                    "Deposit": res.response.data[0].fieldData["Deposit"],
                    "EquipmentBEOTotalAll": res.response.data[0].fieldData["Equipment BEOTotal All"],
                    "EquipmentBEOTotal": res.response.data[0].fieldData["Equipment BEOTotal"],
                    "EquipmentBEOTotalServiceFeeLine": res.response.data[0].fieldData["Equipment BEOTotal ServiceFeeLine"],
                    "EquipmentBEOTotalTax": res.response.data[0].fieldData["Equipment BEOTotal Tax"],
                    "EventContractTextBottomSE": res.response.data[0].fieldData["Event Contract Text Bottom SE"],
                    "EventContractTextTopSE": res.response.data[0].fieldData["Event Contract Text Top SE"],
                    "EventDate": res.response.data[0].fieldData["Event Date"],
                    "EventEndDate": res.response.data[0].fieldData["Event End Date"],
                    "EventTheme": res.response.data[0].fieldData["Event Theme"],
                    "Comments": res.response.data[0].fieldData["Event comments::Comments"],
                    "EventEndTime": res.response.data[0].fieldData["EventEndTime"],
                    "EventStartTime": res.response.data[0].fieldData["EventStartTime"],
                    "FoodBEOTotal": res.response.data[0].fieldData["FoodBEOTotal"],
                    "FoodBEOTotalAll": res.response.data[0].fieldData["FoodBEOTotal All"],
                    "FoodBEOTotalServiceFeeLine": res.response.data[0].fieldData["FoodBEOTotal ServiceFeeLine"],
                    "FoodBEOTotalTax": res.response.data[0].fieldData["FoodBEOTotal Tax"],
                    "FunBEOTotalAll": res.response.data[0].fieldData["Fun BEOTotal All"],
                    "FunBEOTotal": res.response.data[0].fieldData["Fun BEOTotal"],
                    "FunBEOTotalServiceFeeLine": res.response.data[0].fieldData["Fun BEOTotal ServiceFeeLine"],
                    "FunBEOTotalTax": res.response.data[0].fieldData["Fun BEOTotal Tax"],
                    "GuestCount": res.response.data[0].fieldData["Guest Count"],
                    "EventsSignatures::INT1": res.response.data[0].fieldData["EventsSignatures::INT1"],
                    "EventsSignatures::INT2": res.response.data[0].fieldData["EventsSignatures::INT2"],
                    "EventsSignatures::INT3": res.response.data[0].fieldData["EventsSignatures::INT3"],
                    "EventsSignatures::INT4": res.response.data[0].fieldData["EventsSignatures::INT4"],
                    "EventsSignatures::INT5": res.response.data[0].fieldData["EventsSignatures::INT5"],
                    "EventsSignatures::INT6": res.response.data[0].fieldData["EventsSignatures::INT6"],
                    "EventsSignatures::INT7": res.response.data[0].fieldData["EventsSignatures::INT7"],
                    "EventsSignatures::INT8": res.response.data[0].fieldData["EventsSignatures::INT8"],
                    "EventsSignatures::INT9": res.response.data[0].fieldData["EventsSignatures::INT9"],
                    "EventsSignatures::INT10": res.response.data[0].fieldData["EventsSignatures::INT10"],
                    "EventsSignatures::INT11": res.response.data[0].fieldData["EventsSignatures::INT11"],
                    "EventsSignatures::INT12": res.response.data[0].fieldData["EventsSignatures::INT12"],
                    "EventsSignatures::INT13": res.response.data[0].fieldData["EventsSignatures::INT13"],
                    "EventsSignatures::INT14": res.response.data[0].fieldData["EventsSignatures::INT14"],
                    "EventsSignatures::INT15": res.response.data[0].fieldData["EventsSignatures::INT15"],
                    "EventsSignatures::INT16": res.response.data[0].fieldData["EventsSignatures::INT16"],
                    "EventsSignatures::INT17": res.response.data[0].fieldData["EventsSignatures::INT17"],
                    "EventsSignatures::INT18": res.response.data[0].fieldData["EventsSignatures::INT18"],
                    "EventsSignatures::INT19": res.response.data[0].fieldData["EventsSignatures::INT19"],
                    "EventsSignatures::INT20": res.response.data[0].fieldData["EventsSignatures::INT20"],
                    "LaborBEOTotalAll": res.response.data[0].fieldData["Labor BEOTotal All"],
                    "LaborBEOTotal": res.response.data[0].fieldData["Labor BEOTotal"],
                    "LaborBEOTotalServiceFeeLine": res.response.data[0].fieldData["Labor BEOTotal ServiceFeeLine"],
                    "LaborBEOTotalTax": res.response.data[0].fieldData["Labor BEOTotal Tax"],
                    "LineTotal": res.response.data[0].fieldData["Line Total"],
                    "LiquorBEOTotalAll": res.response.data[0].fieldData["Liquor BEOTotal All"],
                    "LiquorBEOTotalServiceFeeLine": res.response.data[0].fieldData["Liquor BEOTotal ServiceFeeLine"],
                    "Location": res.response.data[0].fieldData["Location"],
                    "PartyName": res.response.data[0].fieldData["Party Name"],
                    "RetailBEOTotal": res.response.data[0].fieldData["Retail BEOTotal"],
                    "RetailBEOTotalAll": res.response.data[0].fieldData["Retail BEOTotal All"],
                    "RetailBEOTotalServiceFeeLine": res.response.data[0].fieldData["Retail BEOTotal ServiceFeeLine"],
                    "RetailBEOTotalTax": res.response.data[0].fieldData["Retail BEOTotal Tax"],
                    "RoomBEOTotalAll": res.response.data[0].fieldData["Room BEOTotal All"],
                    "RoomBEOTotal": res.response.data[0].fieldData["Room BEOTotal"],
                    "RoomBEOTotalServiceFeeLine": res.response.data[0].fieldData["Room BEOTotal ServiceFeeLine"],
                    "RoomBEOTotalTax": res.response.data[0].fieldData["Room BEOTotal Tax"],
                    "SalesRep": res.response.data[0].fieldData["SalesRep"],
                    "SalesRep2": res.response.data[0].fieldData["SalesRep 2"],
                    "ServiceFeeTotal": res.response.data[0].fieldData["ServiceFeeTotal"],
                    "ServiceFeeTotalTax": res.response.data[0].fieldData["ServiceFeeTotal Tax"],
                    "EventsSignatures::SignatureText": res.response.data[0].fieldData["EventsSignatures::SignatureText"],
                    "EventsSignatures::Signed": res.response.data[0].fieldData["EventsSignatures::Signed"],
                    "SiteContactEmail": res.response.data[0].fieldData["SiteContactEmail"],
                    "SiteContactFullName": res.response.data[0].fieldData["SiteContactFullName"],
                    "SiteContactPhone": res.response.data[0].fieldData["SiteContactPhone"],
                    "Status": res.response.data[0].fieldData["Status"],
                    "SubTotalWSF": res.response.data[0].fieldData["SubTotalWSF"],
                    "TaxTotal": res.response.data[0].fieldData["Tax Total"],
                    "TerritoryName": res.response.data[0].fieldData["Territory Name"],
                    "Total": res.response.data[0].fieldData["Total"],
                    "TotalPerGuest": res.response.data[0].fieldData["Total Per Guest"],
                    "emailHash": res.response.data[0].fieldData["emailHash"],
                    "match": res.response.data[0].fieldData["match"],
                    "__PK_BEO_ID": res.response.data[0].fieldData["__PK_BEO_ID"],
                    "recordID": res.response.data[0].fieldData["recordID"],
                    "eventItems": res.response.data[0].portalData.Event_Items,
                    "eventPayments": res.response.data[0].portalData.EventPayments,
                    "salesRepTerritory": res.response.data[0].fieldData["Territory 2::Sales Rep Primary"],
                    "SalesRepEmail": res.response.data[0].fieldData["Territory 2::SalesRepEmail"],
                    "resouceItems": res.response.data[0].portalData.EventResources
                });
                setIsLoading(false)
                // console.log(homeData)
            }).catch((err) => {
                // console.log("err")
                setIsLoading(false)
                setIsError(true)
                // console.log(err)
            })

    }
    function goToContract() {
        navigate(`/${id}/contract`, {
            state: { contract: homeData },
        });
    }
    function goToContractView() {
        navigate(`/${id}/contractview`, {
            state: { contract: homeData },
        });
    }
    function goToPayment() {
        navigate(`/${id}/payment`);
    }
    const Completionist = () => <span>You are good to go!</span>;


    const calculateTimeLeft = () => {
        let year = new Date().getFullYear();
        let difference = +new Date(`${homeData.ContractSignatureEXP}`) - +new Date();

        // console.log(homeData.ContractSignatureEXP)
        let timeLeft = {};

        if (difference > 0) {
            if (Math.floor(difference / (1000 * 60 * 60 * 24)) === 1) {
                timeLeft = {
                    day: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    // seconds: Math.floor((difference / 1000) % 60)
                };
            } else {
                timeLeft = {
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60)
                };
            }

        }

        return timeLeft;
    }
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 10);

        return () => clearTimeout(timer);
    });
    const timerComponents = [];

    Object.keys(timeLeft).forEach((interval) => {
        if (!timeLeft[interval]) {
            return;
        }

        timerComponents.push(

            <span key={interval}>
                {timeLeft[interval]} {interval}{" "}
            </span>

        );
    });
    return (<>
        {isLoading ? (<div style={{ backgroundColor: '#006e96' }} className="h-55">

            <Container className=" p-5" >

                <Row className="m-auto">
                    <div className="text-center text-light">
                        {retrived ? (<> <p >Loading...</p>
                            <img src={logo} className="App-logo" alt="logo" /></>) : (<p >No Results Found. Please contact your PinStack Rep.</p>
                        )}

                    </div>

                </Row>
            </Container>



        </div>
        ) : (
            isError ? (<Container className="p-5  " style={{ minHeight: '100%' }}>

                <Row className="m-auto ">
                    <h2 className="text-light text-center mb-3">There was an error processing your request.</h2>

                    <p className="text-light m-auto mb-4 text-center">
                        Please contact your PinStack Rep.
                    </p>


                </Row>
            </Container>) : (<div >

                <Container className="p-5  " style={{ minHeight: '100%' }}>

                    <Row className="m-auto ">
                        <h2 className="text-light text-center mb-3">We are excited for your event on {homeData.EventDate}.</h2>
                        <Col>
                            <Row className="m-auto mb-4">
                                {homeData['EventsSignatures::Signed'] == 1 ? (<>       <Col sm></Col>
                                    <Col sm className="text-light text-center">
                                        <h5  >View your contract</h5>
                                        <Button variant="danger" onClick={() => goToContractView()}>View Contract</Button>
                                    </Col>
                                    <Col sm></Col> </>) : (<>    <Col sm></Col>
                                        <Col sm className="text-light text-center">
                                            <h5 id="timer"  > You have  {timerComponents.length ? (timerComponents) : <span></span>}   to sign the contract or the event will be cancelled.</h5>
                                            <Button variant="danger" onClick={() => goToContract()}>Sign Contract</Button>
                                        </Col>
                                        <Col sm></Col> </>)}




                            </Row>
                            <Row className="m-auto ">
                                <Col sm></Col>
                                {homeData["EventsSignatures::Signed"] === "1" ? (homeData.Balance <= 0 ? (<Col sm className="text-light text-center">
                                    <h5 >Your contract is currently paid in full.</h5>

                                </Col>) : (

                                    <Col sm className="text-light text-center">
                                        <h5 >You currently owe ${(Math.round(homeData.Balance * 100) / 100).toFixed(2)}</h5>
                                        <Button onClick={() => goToPayment()} variant="danger">Make Payment</Button>
                                    </Col>

                                )) : ('')}

                                <Col sm></Col>
                            </Row>
                        </Col>

                    </Row>
                </Container>

    

            </div>)

        )
        }
    </>
    )
}
export default Home;